import { AbstractControl, FormControl, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { File as FileData } from '@tran-monorepo/interfaces/files';
import { evaluateRequiredDocuments, hasRequiredSubjectAreas } from './application-progress-checks.utils';

export function mandatoryDocumentsValidator(control: AbstractControl): ValidationErrors | null {
    const files = (control.value ?? []) as ReadonlyArray<Pick<FileData, 'name' | 'status'>>;
    const result = evaluateRequiredDocuments(files);
    const errors: ValidationErrors = {};

    if (!result.hasMinFiles) {
        errors['documentsMinTwo'] = true;
    }
    if (!result.hasPpt) {
        errors['documentsMissingPpt'] = true;
    }
    if (!result.hasXls) {
        errors['documentsMissingXls'] = true;
    }

    return Object.keys(errors).length > 0 ? errors : null;
}

export function subjectAreasAtLeastOneRequired(control: AbstractControl): ValidationErrors | null {
    const value = (control.value ?? {}) as {
        subjectAreas?: ReadonlyArray<unknown>;
        additionalSubjectAreas?: ReadonlyArray<unknown>;
    };

    return hasRequiredSubjectAreas(value.subjectAreas ?? [], value.additionalSubjectAreas ?? [])
        ? null
        : { subjectAreasRequired: true };
}

export const APPLICATION_PROGRESS_VALIDATORS: Record<string, ValidatorFn[]> = {
    name: [Validators.required],
    applicants: [Validators.required, Validators.minLength(1)],
    locations: [Validators.required, Validators.minLength(1)],
    affectedOrgUnits: [Validators.required, Validators.minLength(1)],
    learningGrowthPartner: [Validators.required],
    betriebsrat: [Validators.required],
    technicalResponsible: [Validators.required],
    commercialResponsible: [Validators.required],
    affectedEmployees: [Validators.required, Validators.min(1)],
    budgets: [Validators.required, Validators.minLength(1)],
    employeeLearningHours: [Validators.required, Validators.min(1)],
    contribution: [Validators.required, Validators.maxLength(2000)],
    involvement: [Validators.required, Validators.maxLength(2000)],
    transferAndScalability: [Validators.required, Validators.maxLength(2000)],
    comment: [Validators.required],
    documents: [Validators.required, mandatoryDocumentsValidator],
    subjectAreaSelection: [subjectAreasAtLeastOneRequired]
};

export function getApplicationProgressValidators(formKey: string): ValidatorFn[] {
    return [...(APPLICATION_PROGRESS_VALIDATORS[formKey] ?? [])];
}

export function isApplicationProgressValueComplete(formKey: string, value: unknown): boolean {
    const control = new FormControl(value, { validators: getApplicationProgressValidators(formKey) });
    return control.valid;
}
